<tui-loader
    [inheritColor]="(loading$ | async) || false"
    [overlay]="(loading$ | async) || false"
    [showLoader]="(loading$ | async) || false"
    [textContent]="contentLoader"
>
    <div class="main-content !pt-0 flex flex-col cart-content bg-white pb-[5rem!important]" #topScrollAnchor>
        <div class="flex items-center gap-2">
            <tui-tabs
                *tuiLet="currentTabIndex$ | async as currentTabIndex"
                [activeItemIndex]="currentTabIndex || 0"
                (activeItemIndexChange)="handleChangeTab($event)"
                class="flex-auto"
            >
                <button tuiTab>{{ 'order_info' | transloco }}</button>

                <button tuiTab [disabled]="isNewCart()">
                    {{ 'order_status' | transloco }}
                </button>
            </tui-tabs>
            <button
                *ngIf="showAddItemButton() && !isFnb"
                tuiButton
                type="button"
                size="s"
                appearance="outline"
                [icon]="'svg::plus'"
                [routerLink]="'/'"
                class="flex-none"
            >
                {{ 'add_items' | transloco }}
            </button>
        </div>

        <tui-carousel
            class="flex-auto w-full max-w-full overflow-x-hidden item-h-full item-p-0"
            *tuiLet="currentTabIndex$ | async as currentTabIndex"
            [index]="currentTabIndex || 0"
            (indexChange)="handleChangeTab($event)"
        >
            <us-cart *tuiItem [className]="currentTabIndex === 1 ? 'shadow-none' : ''"></us-cart>
            <ng-container *ngIf="!isNewCart()">
                <div *tuiItem class="overflow-y-auto">
                    <us-order-status [order]="cart()"></us-order-status>
                </div>
            </ng-container>
        </tui-carousel>
    </div>
    <ng-container *ngIf="cart$ | async as cart">
        <footer class="sticky bottom-0 bg-white w-full border-t py-4 px-2" *ngIf="isFnb">
            <us-cart-checkout-btn [cart]="cart"></us-cart-checkout-btn>
        </footer>
    </ng-container>
</tui-loader>
<ng-template #contentLoader>
    <tui-avatar *ngIf="shop().logo" [avatarUrl]="shop().logo" size="l" class="mb-4"></tui-avatar>
</ng-template>
